<template>
    <div class="pt-[20px] bg-[#ededed]">
        <div class="max-w-[1400px] w-full container mx-auto">
            <div class="lg:pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]">
                <h2 class="pt-5 pb-4 mt-4 text-sm lg:text-2xl">
                    <strong>Aufgaben</strong> - neue Aufgabe erstellen
                </h2>
                <h3 class="pb-3 text-lg max-lg:text-sm">
                    Bearbeitung durch: <strong> Username{{}}</strong>
                </h3>
            </div>
        </div>
    </div>
    <div class="max-w-[1400px] w-full container mx-auto">
        <div class="pt-[60px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]">
            <div class="mb-5">
                <jobForm />
            </div>
        </div>
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue'
    import jobForm from '@/components/Timesheet/TimesheetCreateJob.vue'

    export default defineComponent({
        data() {
            return {
                screenWidth: window.innerWidth,
            }
        },
        components: {
            jobForm,
        },
        mounted() {
            window.addEventListener('resize', this.getDimensions)
        },
        methods: {
            getDimensions() {
                this.screenWidth = document.documentElement.clientWidth
            },
        },
    })
</script>
